import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
const tilts = ['md:-rotate-1', 'md:rotate-1 md:translate-y-6', 'md:rotate-1', 'md:-rotate-1 md:translate-y-6'];
export function Testimonials() {
  if (testimonials.length === 0) return null;
  return <section id="testimonials" className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-278" data-mp="3b1487m19019j">
      <div className="mx-auto max-w-6xl" data-id="element-279" data-mp="36z94ybzrbdt4">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-280" data-mp="36wwfldro6161">
          <div className="lg:col-span-7" data-id="element-281" data-mp="31yv0f3xd6lzu">
            <div className="flex gap-1 text-amber-400" aria-hidden="true" data-id="element-282" data-mp="32291m8uakp5p">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-7 w-7 fill-current sm:h-8 sm:w-8" strokeWidth={0} data-id="element-283" data-mp="2s2i7i89n8c65" data-mpi={i} />)}
            </div>
            <h2 className="mt-6 font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-284" data-mp="v859fwccnb29">
              What <em className="text-red-300" data-id="element-285" data-mp="qavanq32ln1r">teachers</em> say
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-stone-50/70 lg:col-span-5" data-id="element-286" data-mp="h559bys2ppvi">
            Less time searching and building from scratch. More time teaching salsa and bachata.
          </p>
        </div>

        <ul className="mt-16 grid gap-8 md:grid-cols-2 md:gap-x-8 md:gap-y-12" data-id="element-287" data-mp="79bnfosgsk12">
          {testimonials.map((item, index) => <li key={item.name} className={`relative flex flex-col rounded-2xl bg-stone-50 p-8 text-slate-900 shadow-2xl shadow-black/50 sm:p-9 ${tilts[index % tilts.length]}`} data-id="element-288" data-mp="c73q9dundqk1" data-mpi={index}>
              <span className="absolute -top-5 left-8 flex h-10 w-10 items-center justify-center rounded-full bg-red-700 text-white shadow-lg shadow-red-700/40" aria-hidden="true" data-id="element-289" data-mp="14u7ql5ispgph">
                <QuoteIcon className="h-4 w-4 fill-current" strokeWidth={0} data-id="element-290" data-mp="v4o47pvvj4pv" />
              </span>

              <div className="flex gap-0.5 text-amber-500" role="img" aria-label="5 out of 5 stars" data-id="element-291" data-mp="1iu90tbkya0hm">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" strokeWidth={0} aria-hidden="true" data-id="element-292" data-mp="1xhqwjkgjbkrw" data-mpi={i} />)}
              </div>

              <blockquote className="mt-5 flex-1 font-serif text-2xl leading-snug" data-id="element-293" data-mp="1sio2sw6090z8">
                “{item.quote}”
              </blockquote>

              <div className="mt-8 flex items-center gap-4 border-t border-slate-900/10 pt-6" data-id="element-294" data-mp="1ojf91rayt33o">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-900 font-serif text-lg text-stone-50" aria-hidden="true" data-id="element-295" data-mp="1jhy6lrcu18kz">
                  {item.name.split(' ').map(part => part[0]).join('')}
                </span>
                <span className="min-w-0" data-id="element-296" data-mp="14sjw2fxisl40">
                  <span className="block font-semibold" data-id="element-297" data-mp="14r8w6r773xi6">{item.name}</span>
                  <span className="block text-sm text-slate-900/60" data-id="element-298" data-mp="10t1hs307f8a5">{item.location}</span>
                </span>
              </div>
              {item.note && <p className="mt-4 text-xs italic text-slate-900/50" data-id="element-299" data-mp="qtk8zcpnoe9y">{item.note}</p>}
            </li>)}
        </ul>
      </div>
    </section>;
}